import { ReactNode } from 'react';
import Navigation from './navigation';
import classes from './custom-layout.module.css';
import CC from '../scripts/combine-classes';

type CustomLayoutProps = {
  align?: 'top' | 'centre';
  children: ReactNode;
  background?: ReactNode,
}

const CustomLayout = ({
  align = 'top',
  children,
  background = null,
}: CustomLayoutProps) => {
  return (
    <>
      <div className={classes.headerHighlight} />
      {background}
      <div className={classes.container}>
        <Navigation />
        <div className={CC(
          classes.content,
          { [classes.alignCentre]: align === 'centre' }
        )}>
          {children}
        </div>
      </div>
    </>
  );
};

export default CustomLayout;